import React from "react";
import { cn, getUrl } from "../lib/helpers";
import Container from "./container";
import ImageG from "./image-g";
import { format } from "date-fns";
import LinkElem from "./link";
import PortableText from "./portableText";

import * as styles from "../styles/components/page-header.module.css";

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface ResponsiveImage {
  desktop?: ImageAsset;
  mobile?: ImageAsset;
}

interface Slug {
  current?: string;
}

interface Taxonomy {
  title?: string;
  slug?: Slug;
}

interface PageHeaderProps {
  title?: string;
  copy?: any[];
  image?: ResponsiveImage;
  date?: string;
  updateCategory?: Taxonomy;
  careerType?: Taxonomy;
  careerLocation?: Taxonomy;
  careerIsRemote?: boolean;
  bigTitle?: boolean;
  smallTitle?: boolean;
  theme?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  title,
  copy,
  image,
  date,
  updateCategory,
  careerType,
  careerLocation,
  careerIsRemote,
  bigTitle,
  smallTitle,
  theme
}) => {
  if (!title) {
    return null;
  }

  const { desktop: desktopImage, mobile: mobileImage } = image || {};

  return (
    <div className={cn(styles.root, styles[theme])}>
      <Container>
        <div className={styles.text}>
          <h1 className={cn(bigTitle && "h1-big", smallTitle && "h2", styles.title)}>{title}</h1>
          {copy && (
            <div className={cn("entry-content", styles.copy, theme)}><PortableText blocks={copy} theme={theme} /></div>
          )}
        </div>

        {(date || updateCategory || careerType || careerLocation || careerIsRemote) && (
          <div className={styles.meta}>
            {date && (
              <div>{format(new Date(date).setDate(new Date(date).getDate() + 1), "MM.dd.yy")}</div>
            )}

            {updateCategory && (
              <div><LinkElem text={updateCategory.title} url={getUrl(updateCategory.slug, 'updates')} noStyle={true} /></div>
            )}

            {careerType && (
              <div>{careerType}</div>
            )}

            {careerLocation && (
              <div>{careerLocation}</div>
            )}

            {careerIsRemote && (
              <div>Remote</div>
            )}
          </div>
        )}
        
        {desktopImage?.asset && (
          <div className={cn(styles.image, updateCategory && styles.small)}>
            <ImageG node={desktopImage} nodeM={mobileImage} />
          </div>
        )}
      </Container>
    </div>
  );
};

export default PageHeader;
